import * as React from 'react';
import Avatar from '@media-ui/core/src/components/Avatar';
import Button from '@media-ui/core/src/components/Button';
import Title from '@media-ui/core/src/components/Title';
import CrossLink from '@media-ui/article/src/components/CrossLink';
import { counterTrigger } from '../../tools/counters';
import * as s from './KindCrosslink.css';
import { IKindCrosslinkProps } from './KindCrosslink.types';
const KindCrosslinkContent: React.FunctionComponent<IKindCrosslinkProps> = (props) => {
    const handleOnClick = () => {
        counterTrigger('articlePetsKindButtonClick');
    };
    return (<div>
      <Avatar className={s.image} size="l" src={props.main_image}></Avatar>
      <Title level="3">Порода</Title>
      <div className={s.text}>{props.name}</div>
      <Button.Link onClick={handleOnClick} target="_blank" href={props.url} wide>
        Подробнее
      </Button.Link>
    </div>);
};
const KindCrosslink: React.FunctionComponent<IKindCrosslinkProps> = (props) => {
    return <CrossLink content={<KindCrosslinkContent {...props}/>}></CrossLink>;
};
export default KindCrosslink;
